var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "external-menu__section__wrapper" },
    [
      _c("cpf-collection"),
      _c(
        "div",
        [
          _vm.isChatTwilioConversationsFlagEnabled
            ? _c("chat-twilio-conversations")
            : _c("chat-twilio"),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "external-menu__section" },
        [
          _vm._l(_vm.menuItems, function (item, index) {
            return [
              item.conditional
                ? _c(
                    "jade-tooltip",
                    {
                      key: index + item.id,
                      staticClass: "external-menu__itens",
                      attrs: {
                        text: _vm.$t(item.label),
                        placement: "top",
                        id: item.id,
                        "data-testid": item.id,
                      },
                    },
                    [
                      _c("jade-action-button", {
                        attrs: { active: item.active, icon: item.icon },
                        on: {
                          click: function ($event) {
                            return _vm.handleClick(item)
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }